/**
 * Página para crear una recogida
 *
 * Solo alta: la edición de recogidas se retiró del producto, y con ella la ruta
 * /recogidas/:id/editar. Si algún día vuelve, RecogidaForm ya admite `recogida`,
 * `cargando`, `error` y `edicion`.
 *
 * Control de acceso: los roles se resuelven en src/routes.js (AuthRoute), NO aquí.
 */
import React, { useContext } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import RecogidasService from "../api/recogidas.api";
import Toasts from "../../../components/notificacion/Toasts";
import { StateContext } from "../../../components/context/StateProvider";
import { RECOGIDA_ESTADO } from "../constants";

import { RecogidaForm } from "../components";

// DECISION: Esta vista es intencionalmente delgada. Solo orquesta RecogidaForm
// y gestiona la navegacion y los toasts. Toda la logica del formulario
// (validaciones, llamadas al servicio) vive en RecogidaForm.
export default function NuevaRecogida() {
    const navigate = useNavigate();
    const { state, updateState } = useContext(StateContext);

    // Navegar al listado al guardar o cancelar
    const navegarARecogidas = () => {
        navigate('/recogidas');
    };

    // Handler para guardar
    const handleGuardar = async (payload) => {
        try {
            const creada = await RecogidasService.create(payload);

            // DECISION: la API responde 200/201 aunque MSoft rechace la recogida; hay que
            // mirar el estado devuelto. Sin esto se anunciaba "creada correctamente" con
            // una recogida en ERROR, y el usuario no se enteraba del rechazo.
            if (creada?.estado === RECOGIDA_ESTADO.ERROR) {
                const motivo = creada.descripcionErrorMsoft || 'MSoft ha rechazado la recogida';
                updateState({
                    toasts: [...state.toasts, Toasts.generateToast(`Guardada con error: ${motivo}`, "warning")],
                });
            } else {
                updateState({
                    toasts: [...state.toasts, Toasts.generateToast("Recogida creada correctamente.", "success")],
                });
            }

            navegarARecogidas();
        } catch (err) {
            console.error('Error al guardar recogida:', err);
            updateState({
                toasts: [...state.toasts, Toasts.generateToast(err.message || "Error al guardar recogida.", "error")],
            });
            throw err;
        }
    };

    // Handler para cancelar
    const handleCancelar = () => {
        navegarARecogidas();
    };

    return (
        <Box id="nueva-recogida" sx={{ width: "100%" }}>
            <RecogidaForm
                onSave={handleGuardar}
                onCancel={handleCancelar}
            />
        </Box>
    );
}
